import { colors } from '../../../../../../../colorVars'
import { Body4 } from '../../../../../../atomic/text/Text'
import { OptionData } from './optionType'

type Props = {
  data: OptionData;
  type: string;
}


export const OptionChainsTableRow = ({data, type}: Props) => {
  const date = data.expiration_date.split('-').slice(1).join('-');
  return (
    <tr>
      <td>
        <Body4 color={colors.lightGrey}>{type}</Body4>
      </td>
      <td>
        <Body4 color={colors.lightGrey}>${data.strike}</Body4>
      </td>
      <td>
        <Body4 color={colors.lightGrey}>{date}</Body4>
      </td>
    </tr>
  )
}